<template>
  <div ref="qr-container" class="qr-code">
    <v-progress-circular v-if="loading" indeterminate/>
  </div>
</template>

<script>
import QRCode from 'qrcode';

export default {
  name: "QrCode",
  props: {
    value: {
      type: String|null,
    },
  },
  data: () => ({
    loading: false,
  }),
  mounted() {
    this.renderQrCode();
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.renderQrCode();
      }
    }
  },
  methods: {
    renderQrCode() {
      if (this.value) {
        this.loading = true;
        QRCode.toCanvas(this.value, {errorCorrectionLevel: 'M'}, (err, canvas) => {
          this.$refs['qr-container'].replaceChildren(canvas);
          this.loading = false;
        })
      }
    }
  }
}
</script>

<style scoped>
.qr-code {
  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 15px;
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/QR/QrCode.vue